import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
// import { Provider } from 'react-redux'
// import { createStore,applyMiddleware } from 'redux'
// import thunk from 'redux-thunk';
// import reducers from './reducers';

// import './asset/scss/main.scss';
import './asset/vendor/font-awesome/css/font-awesome.min.css';
import './asset/css/main.css';
import './asset/css/blog.css';
import './Components/forms/PremiumFormTheme.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
